// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"8c1be7051df1f41204d8","678":"5bdd31276bed96947b28"}[chunkId] + ".js";
};